// extracted by mini-css-extract-plugin
module.exports = {"table":"WebhookEndpointsTable_table__cZfVB"};